const parser = new DOMParser()

export const starsPostFilterMenu: (advertUrl: string, postCounts: StarsPostCountData) => HTMLElement | undefined = (
    advertUrl: string,
    postCounts: StarsPostCountData,
): HTMLElement | undefined =>
    parser.parseFromString(
        `
    <div class="stars-filter-container">
        <div class="slidemenu-stars-filter scroll-me lavert-card-header-menu starsPostFilter">
            <a href="${advertUrl}#starPosts=alle" class="btn-grey-menu m-10-t">Alle ${postCounts.alle}</a>
            <a href="${advertUrl}#starPosts=for-fans" class="btn-grey-menu m-10-t">Für Fans ${postCounts["for-fans"]}</a>
            <a href="${advertUrl}#starPosts=freigeschaltet" class="btn-grey-menu m-10-t">Freigeschaltet ${postCounts.freigeschaltet}</a>
            <a href="${advertUrl}#starPosts=freischaltbar" class="btn-grey-menu m-10-t">Freischaltbar ${postCounts.freischaltbar}</a>
        </div>
    </div>
`,
        "text/html",
    )?.body.firstChild as HTMLElement | undefined

export const starsPostFooterButton: () => string | undefined = (): string | undefined =>
    `
             <div class="container">
                <div class="btn-cont">
                    <div class="p-10-v"><button data-busy-label="Lädt..." data-default-label="Mehr Beiträge laden" id="load-posts-btn" class="btn-lila m-15-t" style="display: block;">Mehr Beiträge laden</button></div>
                </div>
            </div>

` as string | undefined

export const starsPostFooterButtonEmpty: () => string | undefined = (): string | undefined =>
    `
    <div class="lavert-card lavert-card-separator no-further-posts">
        <div class="container">
            <div class="lavert-card-inner">
                <span>Keine weiteren Beitr&auml;ge</span>
            </div>
        </div>
    </div>

` as string | undefined
